module.exports = __webpack_public_path__ + "img/bannerForLink.6b0117d6.jpg";